import TurndownService from 'turndown';

const turndown = new TurndownService({
  headingStyle: 'atx',
  bulletListMarker: '-',
  strongDelimiter: '**',
  emDelimiter: '*'
});

const EMPTY_HTML_VALUES = ['<p><br></p>', '<p><br/></p>', ''];

export function htmlToMarkdown(html: string): string {
  if (EMPTY_HTML_VALUES.includes(html)) return '';
  return turndown.turndown(html).trim();
}
